import http from "../../http";

/** 微信订阅消息原始模板库 — /resident/api/resident/houseWxSubscribeTpl */
const BASE = "/resident/api/resident/houseWxSubscribeTpl";

const wxSubscribeTpl = {
  selectPage(r) {
    return http.get(`${BASE}/page`, r);
  },
  selectById(r) {
    return http.get(`${BASE}/detail`, r);
  },
  save(r) {
    return http.payload(`${BASE}/save`, r);
  },
  updateStatus(r) {
    return http.tip.post(`${BASE}/updateStatus`, r);
  },
  delete(r) {
    return http.confirm.post(`${BASE}/delete`, r);
  },
};

export default wxSubscribeTpl;
